import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { getRandomId } from 'src/app/shared/extensions/string.extensions';

@Component({
    selector: 'app-standard-toggle-switch',
    templateUrl: './standard-toggle-switch.component.html',
    styleUrls: ['./standard-toggle-switch.component.scss'],
    standalone: false,
})
export class StandardToggleSwitchComponent implements ControlValueAccessor {
    public control = inject(NgControl, { self: true, optional: true });

    @Input() public label: string;
    @Input() public hint: string;
    @Input() public infoText: string;
    @Input() public disabled = false;
    @Input() public rectangularSwitch: boolean;
    @Input() public checked: boolean | number;
    @Input() public toggledLabel = 'On';
    @Input() public toggledTooltip: string;
    @Input() public notToggledLabel = 'Off';
    @Input() public notToggledTooltip: string;
    @Output() public toggleChanged = new EventEmitter<boolean | number>();

    public id: string;

    constructor() {
        if (this.control) {
            this.control.valueAccessor = this;
        }
        this.id = getRandomId();
    }

    public onChangeFn = (_: boolean | number) => {
        return;
    };

    public onTouchedFn = () => {
        return;
    };

    public writeValue(value: boolean | number): void {
        if (value != null && !Number.isNaN(value)) {
            this.checked = value;
        } else {
            this.checked = false;
        }
    }

    public registerOnChange(fn: () => void): void {
        this.onChangeFn = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouchedFn = fn;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    public onChange() {
        this.onChangeFn(this.checked);
        this.toggleChanged.emit(this.checked);
    }
}
